import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";


import Button from "components/CustomButtons/Button.js";

import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import {Modal} from "@material-ui/core";
import {SnackbarContent} from "@material-ui/core";


const useStyles = makeStyles(javascriptStyles);

const ContactModal = (props) => {
    const classes = useStyles();
    return (
        <SnackbarContent
            style={{position: 'fixed', bottom: 0, right: 0, left: 0, backgroundColor: 'rgb(245, 90, 78)'}}
            message={
                <span><b>전송 실패</b> 알 수 없는 오류가 발생했습니다. 고객센터로 문의해주세요.</span>
            }
            close
            color="warning"
            icon="info_outline"
        />
    )
};

export default ContactModal;